// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"b4c04022ea2d790203af","873":"43534e5f75be728e1fc4"}[chunkId] + ".js";
};